import { createAction } from '@reduxjs/toolkit';

const addAssetProductLinks = createAction('asset/addAssetProductLinks');

export default addAssetProductLinks;
